const Footer = () => {
    return (
      <div className="Footer-container">
         <h3 align="center">Shubham's Foodary © 2023</h3>
      </div>
    );
  }
  export default Footer;